function Services() {
  return (
    <section className="section" id="services">
      <div className="container">
        <div className="row">
          <header className="col-12">
            <div className="section-heading heading-center">
              <div className="section-subheading">Áreas de atuação</div>
              <h2>Nossos Serviços</h2>
            </div>
          </header>
          <div className="col-lg-4 col-md-6 col-12 item">
            <a href="#!" className="iitem item-style iitem-hover">
              <div className="iitem-icon">
                <i className="material-icons material-icons-outlined md-48">corporate_fare</i>
              </div>
              <div className="iitem-icon-bg">
                <i className="material-icons material-icons-outlined">corporate_fare</i>
              </div>
              <h3 className="iitem-heading item-heading-large">Sistemas de Gestão Empresarial</h3>
              <div className="iitem-desc">
                Desenvolvemos ERPs e sistemas de gestão personalizados para diferentes segmentos, 
                como indústria, comércio, saúde, educação e logística. Cada solução é construída 
                sob medida para atender as demandas específicas do seu negócio.
              </div>
            </a>
          </div>
          <div className="col-lg-4 col-md-6 col-12 item">
            <a href="#!" className="iitem item-style iitem-hover">
              <div className="iitem-icon">
                <i className="material-icons material-icons-outlined md-48">code</i>
              </div>
              <div className="iitem-icon-bg">
                <i className="material-icons material-icons-outlined">code</i>
              </div>
              <h3 className="iitem-heading item-heading-large">Desenvolvimento Sob Medida</h3>
              <div className="iitem-desc">
                Criamos aplicações web e mobile exclusivas para resolver problemas reais da sua empresa. 
                Analisamos seu cenário e desenvolvemos a ferramenta ideal para otimizar processos, 
                reduzir custos e aumentar a produtividade da sua equipe.
              </div>
            </a>
          </div>
          <div className="col-lg-4 col-md-12 col-12 item">
            <a href="#!" className="iitem item-style iitem-hover">
              <div className="iitem-icon">
                <i className="material-icons material-icons-outlined md-48">cloud_download</i>
              </div>
              <div className="iitem-icon-bg">
                <i className="material-icons material-icons-outlined">cloud_download</i>
              </div>
              <h3 className="iitem-heading item-heading-large">Integrações e Automação</h3>
              <div className="iitem-desc">
                Conectamos seus sistemas existentes, automatizamos fluxos de trabalho e criamos 
                APIs para integrar plataformas distintas. Unificamos sua operação tecnológica 
                para que sua empresa funcione de forma inteligente e integrada.
              </div>
            </a>
          </div>
          <div className="section-footer col-12 section-footer-animate">
            <div className="btn-group align-items-center justify-content-center">
              <a href="#contact-form" className="btn btn-with-icon btn-w240 ripple">
                <span>Solicite um Orçamento</span>
                <svg className="btn-icon-right" viewBox="0 0 13 9" width="13" height="9">
                  <use xlinkHref="/assets/img/sprite.svg#arrow-right"></use>
                </svg>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export default Services;
